"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var use_previous_1 = __importDefault(require("use-previous"));
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var areArraysEqual_1 = require("../../utils/areArraysEqual");
var Icon_1 = __importDefault(require("../Icon"));
var Label_1 = __importDefault(require("../Label"));
var Typography_1 = __importDefault(require("../Typography"));
var TextInput_1 = __importDefault(require("../TextInput"));
var Spinner_1 = __importDefault(require("../Button/Spinner"));
var MultiSelectedValues_1 = __importDefault(require("./MultiSelectedValues"));
var DropdownOptions_1 = __importDefault(require("./DropdownOptions"));
var styles_1 = require("./styles");
var consts_1 = require("./consts");
var Dropdown = function (props) {
    var _a, _b;
    var label = props.label, required = props.required, options = props.options, value = props.value, placeholder = props.placeholder, _c = props.size, size = _c === void 0 ? 'lg' : _c, _d = props.floatable, floatable = _d === void 0 ? false : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.autoComplete, autoComplete = _f === void 0 ? false : _f, onCustomOptionSelect = props.onCustomOptionSelect, onChange = props.onChange, testId = props.testId, displayValue = props.displayValue, onFocus = props.onFocus, onBlur = props.onBlur, maxLength = props.maxLength, clearable = props.clearable, onCustomClearAction = props.onCustomClearAction, onKeyDownHandler = props.onKeyDownHandler, hint = props.hint, validation = props.validation, ignoreFilter = props.ignoreFilter, noMarginBottom = props.noMarginBottom, clearButtonAriaLabel = props.clearButtonAriaLabel, isLoading = props.isLoading;
    var _g = (0, react_1.useState)(false), isOpen = _g[0], setIsOpen = _g[1];
    var valueText = displayValue || ((_a = options.find(function (o) { return o.value === value; })) === null || _a === void 0 ? void 0 : _a.label) || '';
    var valueImg = (_b = options.find(function (o) { return o.value === value; })) === null || _b === void 0 ? void 0 : _b.imageUrl;
    var _h = (0, react_1.useState)(options.findIndex(function (o) { return o.value === value; }) || 0), selectedOption = _h[0], setSelectedOption = _h[1];
    var _j = (0, react_1.useState)(value ? valueText : ''), filterValue = _j[0], setFilterValue = _j[1];
    var _k = (0, react_1.useState)(options), filteredOptions = _k[0], setFilteredOptions = _k[1];
    var _l = (0, react_1.useState)(autoComplete ? filteredOptions : options), optionsToMap = _l[0], setOptionsToMap = _l[1];
    var _m = (0, react_1.useState)(false), isShowCustomOption = _m[0], setIsShowCustomOption = _m[1];
    var containerRef = (0, react_1.useRef)(null);
    var prevOptions = (0, use_previous_1.default)(options);
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
            if (selectedOption > filteredOptions.length - 1) {
                setSelectedOption(Math.max(filteredOptions.length - 1, 0));
            }
        }
        else {
            setFilterValue(valueText);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [isOpen, selectedOption, filteredOptions.length, valueText]);
    (0, react_1.useEffect)(function () {
        var updateOptions = autoComplete ? filteredOptions : options;
        setOptionsToMap(updateOptions);
        if (selectedOption > updateOptions.length - 1) {
            setSelectedOption(Math.max(updateOptions.length - 1, 0));
        }
    }, [filteredOptions, options, autoComplete, selectedOption]);
    (0, react_1.useEffect)(function () {
        setIsShowCustomOption(!!onCustomOptionSelect &&
            !!filterValue &&
            optionsToMap.length !== 1 &&
            optionsToMap.every(function (o) { return o.label !== filterValue; }));
    }, [filterValue, optionsToMap, onCustomOptionSelect]);
    (0, react_1.useEffect)(function () {
        if ((0, areArraysEqual_1.areArraysEqual)(prevOptions || [], options))
            return;
        if (ignoreFilter && autoComplete && options.length > 0) {
            setFilteredOptions(options);
            setOptionsToMap(options);
        }
        else if (ignoreFilter && (!options || options.length === 0)) {
            setFilteredOptions([]);
            setOptionsToMap([]);
        }
        else if (!ignoreFilter) {
            var filtered = options.filter(function (o) { return o.label.toLowerCase().includes(filterValue.toLowerCase()); });
            setFilteredOptions(filtered);
            setOptionsToMap(filtered);
        }
    }, [options, ignoreFilter, autoComplete, prevOptions, filterValue]);
    var handleToggle = function () {
        setIsOpen(function (value) { return !value; });
    };
    var handleSelectOption = function (newValue) {
        var _a;
        if (!Array.isArray(value)) {
            setIsOpen(false);
        }
        if (Array.isArray(value)) {
            if (value.includes(newValue)) {
                onChange(value.filter(function (v) { return v !== newValue; }));
            }
            else {
                onChange(__spreadArray(__spreadArray([], value, true), [newValue], false));
            }
        }
        else {
            onChange(newValue);
            var selectedOptionLabel = (_a = optionsToMap.find(function (o) { return o.value === newValue; })) === null || _a === void 0 ? void 0 : _a.label;
            setSelectedOption(optionsToMap.findIndex(function (o) { return o.value === newValue; }));
            setFilterValue(selectedOptionLabel !== null && selectedOptionLabel !== void 0 ? selectedOptionLabel : '');
            setIsOpen(false);
        }
    };
    var handleCustomOptionSelect = function () {
        var isCustomOptionAlreadyInList = optionsToMap.some(function (o) { return o.label === filterValue; });
        if (!isCustomOptionAlreadyInList) {
            onCustomOptionSelect === null || onCustomOptionSelect === void 0 ? void 0 : onCustomOptionSelect(filterValue);
        }
        onCustomOptionSelect === null || onCustomOptionSelect === void 0 ? void 0 : onCustomOptionSelect(filterValue);
        setIsOpen(false);
    };
    var handleFilter = function (e) {
        var value = e.target.value;
        setFilterValue(value);
        if (autoComplete && onKeyDownHandler) {
            onKeyDownHandler(value);
        }
        if (ignoreFilter) {
            setFilteredOptions(options);
            setOptionsToMap(options);
            setIsOpen(true);
        }
        else {
            var filteredOptions_1 = options.filter(function (o) { return o.label.toLowerCase().includes(value.toLowerCase()); });
            setFilteredOptions(filteredOptions_1);
            setOptionsToMap(filteredOptions_1);
            setIsOpen(true);
        }
    };
    var handleFocus = function () {
        if (!ignoreFilter) {
            setFilteredOptions(options);
            setOptionsToMap(options);
        }
        setIsOpen(true);
    };
    var handleKeyDown = function (e) {
        var _a, _b, _c;
        var key = e.key;
        var optionsEl = document.querySelectorAll('[role="option"]');
        var handleArrow = function (direction) {
            var _a, _b;
            var optionToScrollTo = (selectedOption + direction + optionsToMap.length) % optionsToMap.length;
            setSelectedOption(optionToScrollTo);
            (_b = (_a = optionsEl[optionToScrollTo]) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, consts_1.SCROLL_OPTIONS);
            // Focus the selected option for better accessibility
            var optionElement = optionsEl[optionToScrollTo];
            if (optionElement) {
                optionElement.focus();
            }
        };
        var handleEnter = function () {
            if (isShowCustomOption) {
                handleCustomOptionSelect();
                return;
            }
            handleSelectOption(optionsToMap[selectedOption].value);
            if (!Array.isArray(value)) {
                setIsOpen(false);
            }
        };
        var handleAlphabet = function () {
            var _a, _b, _c, _d;
            var matchingOptions = optionsToMap.filter(function (o) { return o.label.toLowerCase().startsWith(key.toLowerCase()); });
            if (matchingOptions.length === 0)
                return;
            if (matchingOptions.length === 1) {
                setSelectedOption(options.indexOf(matchingOptions[0]));
                (_b = (_a = optionsEl[optionsToMap.indexOf(matchingOptions[0])]) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, consts_1.SCROLL_OPTIONS);
            }
            else {
                var currentOption = matchingOptions.indexOf(optionsToMap[selectedOption]);
                var nextOption = (currentOption + 1) % matchingOptions.length;
                setSelectedOption(optionsToMap.indexOf(matchingOptions[nextOption]));
                (_d = (_c = optionsEl[optionsToMap.indexOf(matchingOptions[nextOption])]) === null || _c === void 0 ? void 0 : _c.scrollIntoView) === null || _d === void 0 ? void 0 : _d.call(_c, consts_1.SCROLL_OPTIONS);
            }
        };
        switch (key) {
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                break;
            case 'ArrowUp':
                e.preventDefault();
                handleArrow(-1);
                break;
            case 'ArrowDown':
                e.preventDefault();
                handleArrow(1);
                break;
            case 'Enter':
                e.preventDefault();
                if (!isOpen) {
                    setIsOpen(true);
                }
                else {
                    handleEnter();
                }
                break;
            case ' ':
            case 'Spacebar': // for older browsers
                if (!autoComplete) {
                    e.preventDefault();
                    setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
                }
                break;
            case 'Tab':
                setIsOpen(false);
                break;
            case 'Home':
                e.preventDefault();
                setSelectedOption(0);
                (_b = (_a = optionsEl[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, consts_1.SCROLL_OPTIONS);
                break;
            case 'End':
                e.preventDefault();
                setSelectedOption(options.length - 1);
                (_c = optionsEl[options.length - 1]) === null || _c === void 0 ? void 0 : _c.scrollIntoView(consts_1.SCROLL_OPTIONS);
                break;
            default:
                if (/^[a-z]$/.test(key)) {
                    if (!autoComplete) {
                        handleAlphabet();
                    }
                }
                break;
        }
    };
    var handleClear = function () {
        setSelectedOption(0);
        onCustomClearAction === null || onCustomClearAction === void 0 ? void 0 : onCustomClearAction();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onChange(undefined);
        if (ignoreFilter) {
            setFilteredOptions([]);
            setOptionsToMap([]);
            setIsOpen(false);
        }
        else {
            setFilterValue('');
            setIsOpen(false);
        }
    };
    var handleClearMouseDown = function (event) {
        event.stopPropagation();
    };
    (0, useClickOutside_1.default)(containerRef, function () { return setIsOpen(false); });
    // Create a descriptive aria-label
    var getAriaLabel = function () {
        if (props['aria-label'])
            return props['aria-label'];
        var ariaLabel = props.label || '';
        // if (props.required && props.label) ariaLabel += ' (required)';
        if (props.placeholder && !props.label)
            ariaLabel = props.placeholder;
        return ariaLabel;
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: containerRef, className: (0, classnames_1.default)({
            disabled: disabled,
            autoComplete: autoComplete,
        }), "data-testid": "".concat(testId, "-container") }, { children: [label && ((0, jsx_runtime_1.jsx)(Label_1.default, __assign({ required: required, htmlFor: testId }, { children: label }))), (0, jsx_runtime_1.jsxs)(styles_1.LabelAndOptionsContainer, __assign({ noMarginBottom: noMarginBottom }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.UpperContainer, { children: [autoComplete ? ((0, jsx_runtime_1.jsx)(TextInput_1.default, { onChange: handleFilter, onFocus: handleFocus, value: filterValue, onKeyDown: handleKeyDown, "data-testid": testId, id: testId, maxLength: maxLength, placeholder: placeholder, disabled: disabled, hint: hint, style: { paddingRight: clearable ? '70px' : 'initial' }, validation: validation, "aria-label": getAriaLabel(), "aria-required": required, "aria-invalid": !!validation, "aria-expanded": isOpen, "aria-haspopup": "listbox" })) : ((0, jsx_runtime_1.jsxs)(styles_1.DropdownValue, __assign({ size: size, isPlaceholder: !value, onMouseDown: handleToggle, "data-testid": testId, id: testId, "aria-haspopup": "listbox", "aria-expanded": isOpen, onKeyDown: handleKeyDown, type: "button", isOpen: isOpen, disabled: disabled, "aria-label": getAriaLabel(), "aria-required": required, "aria-invalid": !!validation }, { children: [valueImg && (0, jsx_runtime_1.jsx)(styles_1.DropdownImage, { style: { backgroundImage: "url(".concat(valueImg, ")") } }), (0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ size: "lg" }, { children: valueText || placeholder }))] }))), isLoading ? ((0, jsx_runtime_1.jsx)(styles_1.ChevronHolder, __assign({ ishintOrValidation: !!(validation || hint), isSpinner: true, autoComplete: autoComplete }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.default, {}) }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.ChevronHolder, __assign({ ishintOrValidation: !!(validation || hint), autoComplete: autoComplete }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: isOpen ? 'chevron-up' : 'chevron-down' }) })), clearable && !!value && ((0, jsx_runtime_1.jsx)(styles_1.ClearButton, __assign({ onClick: handleClear, onMouseDown: handleClearMouseDown, ishintOrValidation: !!hint || !!validation, "aria-label": clearButtonAriaLabel || 'Clear selection' }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "close", testId: "".concat(testId, "-close") }) })))] }))] }), isOpen && (optionsToMap.length > 0 || isShowCustomOption) && ((0, jsx_runtime_1.jsx)(DropdownOptions_1.default, __assign({}, props, { optionsToMap: optionsToMap, isShowCustomOption: isShowCustomOption, handleSelectOption: handleSelectOption, valueText: valueText, selectedOption: selectedOption, filterValue: filterValue, onCustomOptionSelect: handleCustomOptionSelect }))), Array.isArray(value) && (floatable || !isOpen) && ((0, jsx_runtime_1.jsx)(MultiSelectedValues_1.default, { value: value, options: options, onChange: onChange }))] }))] })));
};
exports.default = Dropdown;
